export const SLOT_TOP = 'top';
export const SLOT_FIXED_WIDGET = 'corner';
export const SLOT_BILLBOARD = 'top';
export const SLOT_BILLBOARD_DOUBLE = 'top';
export const SLOT_BILLBOARD_TRIPLE = 'top';
export const SLOT_BOX = 'flat-boxright1';
export const SLOT_BOX_BIG = 'flat-boxleft1';
export const SLOT_BOX_DOUBLE = 'flat-boxright2';
export const SLOT_RECTANGLE = 'left';
export const SLOT_BELKA_1 = 'flat-panel';
export const SLOT_BELKA_2 = 'flat-panel';
export const SLOT_POSITIONER_1_GRIG = 'flat-pozycjoner';
export const SLOT_POSITIONER_2_GRIG = 'flat-pozycjoner2';
export const SLOT_POSITIONER_1_LIST = 'flat-pozycjoner';
export const SLOT_POSITIONER_2_LIST = 'flat-pozycjoner2';
export const SLOT_POSITIONER_PROMOTED_1 = 'flat-pozycjoner-proponowane1';
export const SLOT_POSITIONER_PROMOTED_2 = 'flat-pozycjoner-proponowane2';
export const SLOT_OSNACZENIE_PRODUCENTA = 'flat-branding';
export const SLOT_CORNER = 'flat-widget';
export const SLOT_CORNER_DOUBLE = 'flat-widget2';
export const SLOT_WIDEBOARD = 'top';
export const SLOT_RESPONSIVE_WIDEBOARD = 'top';
export const SLOT_DOUBLE_RESPONSVE = 'top';
export const SLOT_SCREENING = 'top';
export const SLOT_SPONSORING_TOP = 'flat-belkagorna';
export const SLOT_SCROLLER = 'flat-pasekrozwijany';
export const SLOT_OFFER_LIST_ELEMENT = 'flat-panel1';
export const SLOT_FIRST_ROW = 'flat-panel';
export const SLOT_SECOND_ROW = 'left';
export const SLOT_PRODUCER_WIDGET_LOGO_1 = 'flat-boxright1';
export const SLOT_PRODUCER_WIDGET_LOGO_2 = 'flat-boxright2';
export const SLOT_PRODUCER_WIDGET_LOGO_3 = 'flat-boxright3';
export const SLOT_PRODUCER_WIDGET_LOGO_4 = 'flat-boxright4';
export const SLOT_PRODUCER_WIDGET_LOGO_5 = 'flat-boxright5';
export const SLOT_PRODUCER_WIDGET_LOGO_6 = 'flat-boxright6';
export const SLOT_PRODUCER_WIDGET_LOGO_7 = 'flat-boxright7';
export const SLOT_PRODUCER_WIDGET_LOGO_8 = 'flat-boxright8';
export const SLOT_LANDING_CONTENT = 'flat-zakladka1';
export const SLOT_SUBDEPARTMENT_SECTION_1 = 'subdepartment-section1';
export const SLOT_SUBDEPARTMENT_SECTION_2 = 'subdepartment-section2';
export const SLOT_SUBDEPARTMENT_SECTION_3 = 'subdepartment-section3';
export const SLOT_SUBDEPARTMENT_SECTION_4 = 'subdepartment-section4';
export const SLOT_SUBDEPARTMENT_SECTION_5 = 'subdepartment-section5';
export const SLOT_SUBDEPARTMENT_SECTION_6 = 'subdepartment-section6';
